var _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 26 26",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 26,
    width: 26,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50002 13C1.50002 6.6487 6.64875 1.49998 13 1.49998C19.3513 1.49998 24.5 6.6487 24.5 13C24.5 19.3512 19.3513 24.5 13 24.5C6.64875 24.5 1.50002 19.3512 1.50002 13Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#5990e4",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphCircle);
export default __webpack_public_path__ + "static/media/graphCircle.d76330df012dee226f76f73a8fecd0c7.svg";
export { ForwardRef as ReactComponent };